import UploadFileModal from '@components/Modals/Shared/UploadFileModal/Index';
import { DocumentCounter } from '@components/UI/DocumentCounter/Index';
import { useState } from 'react';

export const UploadFileHandler = ({ row }) => {

  const idSolicitacaoProcessoItem = row.id;
  const idSolicitacao = row.idSolicitacao;  
  const [visible, setVisible] = useState(false);

  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <i
          className="fa-solid fa-file-arrow-up fs-6"
          onClick={openModal}
          style={{ color: "#2b97be", cursor: "pointer" }}
          title="Abrir modal para upload de documentos."
        />
        <DocumentCounter idSolicitacaoProcessoItem={idSolicitacaoProcessoItem} />
      </div>

        <UploadFileModal
          visible={visible}
          idSolicitacaoProcessoItem={idSolicitacaoProcessoItem}
          idSolicitacao={idSolicitacao}
          closeModal={closeModal}
        />
     
    </>
  );
};

export default UploadFileHandler;